module.exports = __webpack_public_path__ + "img/win-close.0412b483.svg";